import { useCallback, useEffect, useState } from "react";
import { PppoeProfileService } from "../services/PppoeProfileService";
import { HotspotProfileService } from "../services/HotspotProfileService";

export const useHookHotspotProfile = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [params, setParams] = useState({});

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await HotspotProfileService.get({params:params});
            setData(res.data.data);
        }catch(err){
            setError(err);
            throw err;
        }finally{
            setLoading(false);
        }
    }, [params]);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,

        params,
        setParams,

        refreshData: () => getData()
    }
}